import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.TRANSACTION_UPLOAD_FILE_CSV.SUCCESS, saga.uploadFileSuccess);
    yield takeLatest(constants.TRANSACTION_UPLOAD_FILE_CSV.FAILED, saga.uploadFileFailed);
}